import { Page, PageHeader } from "@dash/page";
import { Pagination } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";

import { useClientManager } from "@megaron/react-clients";

import { CartsFilters } from "./CartsFilters";
import { CartsTable } from "./CartsTable";
import { useCartsFilters } from "./useCartsFilters";

export const CartsHome = () => {
  const { filters, setFilter, setFilters } = useCartsFilters();

  const pageSize = 20;
  const page = filters.page ?? 0;
  const offset = page * pageSize;

  const fulfillmentClient = useClientManager("fulfillment");

  const cartsQuery = fulfillmentClient.cartsQuery().useQuery({
    limit: pageSize,
    offset,
    isArchived: filters.isArchived,
    isFulfilled: filters.isFulfilled,
    hasRewards: filters.hasRewards,
    excludeEmpty: filters.excludeEmpty,
    userId: filters.searchTerm,
  });

  return (
    <Page css={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "100%" }}>
      <PageHeader>Zarządzanie koszykami</PageHeader>
      <div
        css={{
          display: "flex",
          gap: "1rem",
          marginBottom: "0.5rem",
          flexWrap: "wrap",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CartsFilters
          values={filters}
          onChange={(patch) => {
            setFilters({ ...filters, ...patch, page: 0 });
          }}
        />
        <Pagination
          css={{ maxHeight: "41px", alignSelf: "flex-end" }}
          page={page}
          onPageChange={(p) => {
            setFilter("page")(p);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          pageSize={pageSize}
          itemCount={cartsQuery.data?.count ?? 0}
        />
      </div>
      <QuerySkeleton query={cartsQuery}>
        {(carts) => <CartsTable isLoading={false} carts={carts.items} />}
      </QuerySkeleton>
    </Page>
  );
};
